export default __webpack_public_path__ + "static/media/cuponExample.23ce4e67.jpg";